export default __webpack_public_path__ + "static/media/night-apocalypse.c3266333.jpg";